import { loaderAction, setSendReceiptFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { GetInvoicesThunk } from "./GetInvoicesThunk";
import { SEND_RECEIPT_FORM_INITIAL } from "../initialStateConstant";

export const MarkPrepaymentThunk = (args) => async (dispatch, getState) => {
    const { user, invoices } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('counterparty_id', args.counterparty_id);
        formData.append('invoice_id', args.invoice_id);
        formData.append('period', args.period);
        formData.append('receipt_sum', args.receipt_sum);

        const response = await api({ data: formData, link: 'mark_prepayment' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список счетов
            dispatch(GetInvoicesThunk({ date: invoices.date }));

            // Закрываем форму отправки чека
            dispatch(setSendReceiptFormAction(SEND_RECEIPT_FORM_INITIAL));

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};